"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var common_1 = require("docs/common");
exports.PropertiesCheckbox = function () { return (React.createElement(common_1.PropertyTable, null,
    React.createElement(common_1.Property, { name: "checked", type: "bool", defaultValue: "false", description: "If true, Checkbox is checked." }),
    React.createElement(common_1.Property, { name: "onChange", type: "function", description: "Triggered when Checkbox changes (checks or unchecks)." }))); };
exports.PropertiesCheckbox.displayName = 'PropertiesCheckbox';



//////////////////
// WEBPACK FOOTER
// ./src/docs/pages/ComponentCheckboxPage/PropertiesCheckbox.tsx
// module id = 652
// module chunks = 0